import { useEffect } from "react";
import { create } from "zustand";

// The page card's slot the canvas portals into (OpusAgentCanvasSlot).
export const OPUS_AGENT_CANVAS_SLOT_ID = "opus-agent-canvas-slot";

// Whether this page can show the canvas at all.
export const canShowOpusAgentCanvas = (): boolean =>
  typeof document !== "undefined" &&
  !!document.getElementById(OPUS_AGENT_CANVAS_SLOT_ID);

// What the agent canvas (the overlay on the main page card) shows. Not
// persisted: a reload, a chat switch, a new chat and logout all close it.
export type OpusAgentCanvasView = {
  kind: "plan";
  chatId: string;
  eventId: string;
  // Whether the canvas takes focus when it shows: true when the person
  // opened it (View plan), false when a live plan opened it, so it never
  // steals focus from the composer.
  focus: boolean;
};

type CanvasState = {
  view: OpusAgentCanvasView | null;
  openPlan: (
    chatId: string,
    eventId: string,
    options?: { focus?: boolean },
  ) => void;
  close: () => void;
};

export const useOpusAgentCanvasStore = create<CanvasState>()((set) => ({
  view: null,
  openPlan: (chatId, eventId, options) =>
    set({
      view: { kind: "plan", chatId, eventId, focus: !!options?.focus },
    }),
  close: () => set({ view: null }),
}));

export const closeOpusAgentCanvas = (): void =>
  useOpusAgentCanvasStore.getState().close();

// The canvas shows the panel's chat's plans: a switch to another chat or a
// new one (selectionKey), closing the panel, and unmounting close it.
export const useCloseCanvasWithChat = ({
  selectionKey,
  active,
}: {
  selectionKey: number;
  active: boolean;
}): void => {
  useEffect(() => {
    closeOpusAgentCanvas();
  }, [selectionKey]);
  useEffect(() => {
    if (!active) closeOpusAgentCanvas();
  }, [active]);
  useEffect(() => () => closeOpusAgentCanvas(), []);
};
